import { f as u, h as b, j as T, c as A, k as D, l as M, m as k, n as w, d as O, i as v, o as N, p as R, q as S, e as x } from "./general-BkFCKlQ-.js";
import { r as q, s as B, t as F, w as I, u as z, v as G } from "./general-BkFCKlQ-.js";
import { j as e, c } from "./format-Cc3xCl5M.js";
import { m as K, n as Q, k as U, o as X } from "./format-Cc3xCl5M.js";
const V = (n, r, a) => a.useValueAsName ? isNaN(Number(n)) ? e(a.option) === n : e(a.option) === Number(n) : e(a.option) === e(r), Y = (n, r, a) => {
  var t, l, y, i, s;
  if (a.useValueAsName) {
    if (a.minDate || a.maxDate)
      return !((t = a.minDate) == null || !t.year) && Number(n) < ((l = a.minDate) == null ? void 0 : l.year) || !((y = a.maxDate) == null || !y.year) && Number(n) > ((i = a.maxDate) == null ? void 0 : i.year);
    if (a.enabledDays)
      return a.enabledDays.every((o) => "start" in o && "end" in o ? o.start.year !== Number(n) || o.end.year !== Number(n) : o.year !== Number(n));
  } else {
    if (a.minDate || a.maxDate)
      return !!a.minDate && (a.minDate.year === e(a.year) && e(r) < a.minDate.month || ((s = a.minDate) == null ? void 0 : s.year) > (e(a.year) || 0)) || !!a.maxDate && a.maxDate.year === e(a.year) && e(r) > a.maxDate.month;
    if (a.enabledDays && e(a.year))
      return O({ year: e(a.year), month: e(r), enabledDays: a.enabledDays });
  }
  return !1;
}, $ = (n, r, a, t) => {
  var l, y, i, s, o, g;
  if (a.useValueAsName) {
    const m = Number(r);
    (l = a.setOption) == null || l.call(a, m), (y = a.onYearChange) == null || y.call(a, m);
    const d = x({ startDay: a.startDay, year: m, type: a.type || "single" });
    d && ((i = a.onChange) == null || i.call(a, d));
  } else {
    (s = a.setOption) == null || s.call(a, n), (o = a.onMonthChange) == null || o.call(a, n);
    const m = x({ startDay: a.startDay, month: n, type: a.type || "single" });
    m && ((g = a.onChange) == null || g.call(a, m));
  }
  t == null || t();
}, H = ({ year: n, month: r, endDay: a, day: t, startDay: l, customDaysClassName: y, multipleObject: i, hideOutSideDays: s, hoverRangeValue: o, minDate: g, maxDate: m, disabledDays: d, enabledDays: C }) => {
  var f;
  const p = `${e(n)}-${u(e(r), t.month)}-${t.value}`;
  return { dayRangeEndHover: j(o, l, t, n, r), dayRangeStartEnd: (e(o).start || l) && (e(o).end || a) && (b({ year: e(n), month: e(r), day: t.value, dateRange: e(o).start || l, monthStatus: t.month }) || b({ year: e(n), month: e(r), day: t.value, dateRange: e(o).end || a, monthStatus: t.month })), dayRangeBetween: T({ year: e(n), month: e(r), day: t.value, startDate: e(o).start || l, endDate: e(o).end || a, monthStatus: t.month }), dayRangeStart: b({ year: e(n), month: e(r), day: t.value, dateRange: e(o).start || l, monthStatus: t.month }), dayRangeEnd: b({ year: e(n), month: e(r), day: t.value, dateRange: e(o).end || a, monthStatus: t.month }), daysCurrent: A(new Date(D(e(n), e(r), t.month), u(e(r), t.month), t.value)) && t.month === "current", daysNotCurrentMonth: t.month !== "current", ...M({ year: e(n), month: e(r), day: t }), customDayClass: (f = y == null ? void 0 : y.find((h) => h.year === D(e(n), e(r), t.month) && h.month === u(e(r), t.month) && h.day === t.value)) == null ? void 0 : f.className, isMultipleSelected: !(i == null || !i.find((h) => h.year === D(e(n), e(r), t.month) && h.month === u(e(r), t.month) && h.day === t.value)), hidden: !!s && t.month !== "current", disabled: k({ disabledDays: d, day: t, month: e(r), year: e(n) }) || w({ day: t, month: r, year: n, minDate: g, maxDate: m }) || O({ enabledDays: C, day: t, month: e(r), year: e(n) }), date: p, dateValue: p };
}, j = (n, r, a, t, l) => {
  var y, i;
  return !!((y = e(n).end) != null && y.day && (i = e(n).start) != null && i.day && r != null && r.day) && (v(e(n).start, r) ? N(e(n).start, { year: D(e(t), e(l), a.month), month: u(e(l), a.month), day: a.value }) : !!v(r, e(n).end) && N(e(n).end, { year: D(e(t), e(l), a.month), month: u(e(l), a.month), day: a.value }));
}, L = ({ year: n, day: r, startDay: a, endDay: t, disabledDays: l, month: y, hover: i, hoverEndDay: s, enabledDays: o, disallowSameDayRange: g }) => {
  if ((a && t || !a && !t) && !i && !s)
    return { start: { year: D(e(n), e(y), r.month), month: u(e(y), r.month), day: r.value }, end: void 0, initial: !0 };
  if (a && !t) {
    const m = new Date(a == null ? void 0 : a.year, a == null ? void 0 : a.month, a == null ? void 0 : a.day), d = new Date(D(e(n), e(y), r.month), u(e(y), r.month), r.value);
    if (m.getTime() === d.getTime())
      return g ? { start: a } : { start: a, end: c(d) };
    if (m.getTime() < d.getTime() && (l && R(m, d, l) || o && S(m, d, o)))
      return i ? { start: a } : { start: c(d), initial: !0 };
    if (m.getTime() > d.getTime() && (l && R(m, d, l) || o && S(d, m, o)))
      return i ? { start: a } : { start: c(d), initial: !0 };
    if (m.getTime() < d.getTime())
      return { end: c(d), start: a };
    if (m.getTime() > d.getTime())
      return { start: c(d), end: c(m) };
  }
  return { start: a, end: t };
};
export {
  H as applyDateRangeProps,
  q as breakArrayIntoSubArrays,
  N as compareObjectDate,
  B as currentYear,
  K as formatHourWithLeadingZero,
  Q as formatMinuteSecondWithLeadingZero,
  F as generateYearsArray,
  u as getDatePickerRefactoredMonth,
  D as getDatePickerRefactoredYear,
  I as getMonthDaysArray,
  x as getOnChangeSingleData,
  z as getRefactoredNextDate,
  G as getRefactoredPrevDate,
  U as getYearRange,
  L as handleDateRange,
  $ as handleSelectorOptionClick,
  O as isNotPartOfEnabledDays,
  Y as isOptionDisabledOnSelector,
  V as isOptionSelectedOnSelector,
  X as numberFormatter
};
